<section class="categories-page">
  <header class="page-header">
    <div>
      <h1>Catégories</h1>
      <p>Créer, modifier et supprimer les catégories utilisées dans les recettes.</p>
    </div>
    <div class="header-actions">
      <button type="button" class="ghost" (click)="loadCategories()" [disabled]="loading">Rafraîchir</button>
      <button type="button" class="primary" (click)="startCreate()" [disabled]="saving">Nouvelle catégorie</button>
    </div>
  </header>

  <p class="message error" *ngIf="errorMessage">{{ errorMessage }}</p>
  <p class="message success" *ngIf="successMessage">{{ successMessage }}</p>

  <div class="layout" [class.editor-open]="showEditor">
    <section class="panel list" [class.full-width]="!showEditor">
      <div class="list-header">
        <h2>Toutes les catégories</h2>
        <input
          type="search"
          [value]="searchQuery"
          (input)="applySearch(($any($event.target).value || '').toString())"
          placeholder="Rechercher une catégorie..."
        />
      </div>

      <div class="state loading-state" *ngIf="loading">
        <span class="spinner" aria-hidden="true"></span>
        <span>Chargement…</span>
      </div>
      <div class="state" *ngIf="!loading && visibleCategories.length === 0">Aucune catégorie.</div>

      <div class="categories-grid" *ngIf="!loading && visibleCategories.length > 0">
        <article class="category-card" *ngFor="let category of visibleCategories">
          <div class="category-cover">
            <ng-container *ngIf="categoryImageUrl(category) as imageUrl; else noImage">
              <img [src]="imageUrl" [alt]="category.name || ('#' + category.id)" />
            </ng-container>
            <ng-template #noImage>
              <div class="cover-placeholder">Aucune image</div>
            </ng-template>
          </div>

          <div class="category-main">
            <strong>{{ category.name || ('#' + category.id) }}</strong>
            <p>{{ category.description || 'Sans description' }}</p>
            <span>Parent: {{ parentLabel(category.parentId) }}</span>
          </div>

          <div class="category-actions">
            <button type="button" class="ghost" (click)="startEdit(category)" [disabled]="saving || uploading">
              Modifier
            </button>
            <button type="button" class="danger" (click)="delete(category)" [disabled]="isDeleting(category.id)">
              {{ isDeleting(category.id) ? 'Suppression…' : 'Supprimer' }}
            </button>
          </div>
        </article>
      </div>

      <footer class="pagination">
        <span>{{ totalItems }} résultat(s)</span>
        <div>
          <button type="button" class="ghost" (click)="previousPage()" [disabled]="currentPage === 0">Préc.</button>
          <span>Page {{ currentPage + 1 }} / {{ totalPages }}</span>
          <button type="button" class="ghost" (click)="nextPage()" [disabled]="currentPage + 1 >= totalPages">Suiv.</button>
        </div>
      </footer>
    </section>

    <section class="panel editor" *ngIf="showEditor">
      <h2>{{ editingCategoryId == null ? 'Ajouter une catégorie' : 'Modifier la catégorie #' + editingCategoryId }}</h2>

      <form [formGroup]="form" (ngSubmit)="save()">
        <label>
          <span>Nom</span>
          <input type="text" formControlName="name" placeholder="Cuisine sénégalaise" />
        </label>

        <label>
          <span>Description</span>
          <textarea rows="4" formControlName="description" placeholder="Description de la catégorie"></textarea>
        </label>

        <label>
          <span>Image (nom de fichier)</span>
          <input type="text" formControlName="imageUrl" placeholder="images/categories/ma-categorie.jpg" />
        </label>

        <div class="image-preview" *ngIf="imagePreviewUrl() as previewUrl">
          <img [src]="previewUrl" alt="Aperçu de la catégorie" />
        </div>

        <label class="file-input">
          <span>Uploader une image</span>
          <input type="file" accept="image/png,image/jpeg,image/webp" (change)="uploadImage($event)" />
          <small class="inline-loading" *ngIf="uploading">
            <span class="spinner sm" aria-hidden="true"></span>
            <span>Upload en cours…</span>
          </small>
        </label>

        <label>
          <span>Catégorie parente</span>
          <select formControlName="parentCategoryId">
            <option [ngValue]="null">Aucune</option>
            <option *ngFor="let category of selectableParentCategories()" [ngValue]="category.id">
              {{ category.name || ('#' + category.id) }}
            </option>
          </select>
        </label>

        <div class="form-actions">
          <button type="submit" class="primary" [disabled]="saving || uploading">
            {{ saving ? 'Enregistrement…' : editingCategoryId == null ? 'Créer la catégorie' : 'Mettre à jour' }}
          </button>
          <button type="button" class="ghost" (click)="closeEditor()" [disabled]="saving || uploading">
            Fermer
          </button>
        </div>
      </form>
    </section>
  </div>
</section>
